export default {
  payerData: {
    name: null,
    cpf: null,
    address: {
      cep: null,
      number: null,
      street: null,
      neighborhood: null,
      city: null,
      state: null,
    },
  },
  payerValidationFields: {},
  downgradeData: null,
};
